import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TopLoaderService {
  private loadingSubject: BehaviorSubject<boolean>;

  constructor() {
    this.loadingSubject = new BehaviorSubject(false);
  }

  setLoading(loading: boolean) {
    this.loadingSubject.next(loading);
  }

  get loading(): boolean {
    return this.loadingSubject.getValue();
  }

  get isLoading$(): Observable<boolean> {
    return this.loadingSubject.asObservable();
  }
}
